import { cn } from '@/lib/cn.ts'

export function InformationIcon ({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'
      className={cn('size-3', className)}
    >
      <g clipPath='url(#clip0_156_10866)'>
        <path
          d='M6 0C9.31368 0 12 2.68629 12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0ZM6 1.2C3.34903 1.2 1.2 3.34903 1.2 6C1.2 8.65098 3.34903 10.8 6 10.8C8.65098 10.8 10.8 8.65098 10.8 6C10.8 3.34903 8.65098 1.2 6 1.2ZM6 5.4C6.33138 5.4 6.6 5.66862 6.6 6V7.8H7.5V9H4.5V7.8H5.4V6.6H4.5V5.4H6ZM5.85 3C6.26424 3 6.6 3.33578 6.6 3.75C6.6 4.16422 6.26424 4.5 5.85 4.5C5.43576 4.5 5.1 4.16422 5.1 3.75C5.1 3.33578 5.43576 3 5.85 3Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_156_10866'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>

  )
}
